import { valibotResolver } from "@hookform/resolvers/valibot";
import { useForm } from "react-hook-form";

import MaxLengthInput from "common/components/MaxLengthInput";
import { Button } from "common/components/ui/Button";
import { DialogTitle } from "common/components/ui/Dialog/Dialog";
import { DrawerTitle } from "common/components/ui/Drawer/Drawer";
import FormField from "common/components/ui/FormField";
import { getSchemaMaxLength } from "common/helpers/utils";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import { CampaignNameSchema } from "common/schemas";

import useCampaignMutations from "../../datahooks/useCampaignMutations";

interface CampaignNameEditProps {
  campaignName: string;
  campaignId: string;
  onClose: () => void;
}

export default function CampaignNameEdit({
  campaignName,
  campaignId,
  onClose,
}: CampaignNameEditProps) {
  const isDesktop = useTwBreakpoint("lg");

  const { updateCampaign, isUpdatingCampaign } = useCampaignMutations();

  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: { name: campaignName },
    resolver: valibotResolver(CampaignNameSchema),
  });

  function updateCampaignName({ name }: { name: string }) {
    updateCampaign({
      updates: { name },
      campaignId,
    }).then(() => {
      reset({ name });
      onClose();
    });
  }

  function onSubmit() {
    handleSubmit(updateCampaignName)();
  }

  const Title = isDesktop ? DialogTitle : DrawerTitle;

  return (
    <>
      <Title className="mb-8">Change campaign name</Title>

      <FormField
        label="Campaign name"
        htmlFor="name-input"
        size="lg"
        className="mb-8"
        error={errors?.name?.message}
      >
        <MaxLengthInput
          variant="lg"
          id="name-input"
          characterLength={watch("name").length}
          maxLength={getSchemaMaxLength(CampaignNameSchema.entries.name)}
          {...register("name")}
        />
      </FormField>

      <div className="flex items-center justify-between gap-x-2.5">
        <Button
          variant="secondary-black"
          className="lg:flex-1"
          disabled={isUpdatingCampaign}
          onClick={onClose}
        >
          Cancel
        </Button>

        <Button
          isLoading={isUpdatingCampaign}
          onClick={onSubmit}
          className="lg:flex-1"
        >
          Save
        </Button>
      </div>
    </>
  );
}
